import openModalAction from 'modules/modal/redux/actions/open'
import { MODAL_ID } from 'modules/modal/redux/constants'

/**
 * @param productVariantImage
 * @param productVariant
 * @returns {(function(*): void)|*}
 */
export default function openAddFullSizeAfterRatingModalProductionAction ({
  productVariantImage,
  productVariant
}) {
  return (dispatch) => {
    dispatch(
      openModalAction(MODAL_ID.ADD_FULL_SIZE_AFTER_RATING, {
        imageUrl: productVariantImage,
        productVariant
      })
    )
  }
}
